"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var oneToFourDigits = '(\\d{1,4})';
var divider = '(-|/)';
var DATE_REGEX = new RegExp("^" + oneToFourDigits + divider + oneToFourDigits + divider + oneToFourDigits + "$", 'i');
var _default = DATE_REGEX;
exports.default = _default;
module.exports = exports.default;